import { NoOp } from 'utils/noop';

import * as t from './actionTypes';
import { DataFeed, DataFeeds, NewDataFeed } from './types';

export type DataFeedFetchRequestAction = {
  type: string;
};

export type DataFeedFetchResponseAction = {
  type: string;
  payload: DataFeeds;
};

export type DataFeedUpdateRequestAction = {
  type: string;
  payload: DataFeed | NewDataFeed;
  cb: NoOp;
};

export type DataFeedUpdateResponseAction = {
  type: string;
  payload: DataFeed;
};

export type DataFeedDeleteRequestAction = {
  type: string;
  id: number;
  cb: NoOp;
};

export type DataFeedDeleteResponseAction = {
  type: string;
  id: number;
};

// error action for any type (fetch, update, delete)
export type DataFeedErrorAction = {
  type: string;
  error: string;
};

export type DataFeedErrorClearAction = {
  type: string;
};

/* -- Other Actions -- */

export const deleteDataFeedsRequest = (id: number, cb: NoOp): DataFeedDeleteRequestAction => ({
  type: t.DELETE_DATA_FEEDS_REQUEST,
  id,
  cb,
});

export const deleteDataFeedsResponse = (id: number): DataFeedDeleteResponseAction => ({
  type: t.DELETE_DATA_FEEDS_RESPONSE,
  id,
});

export const deleteDataFeedsError = (error: string): DataFeedErrorAction => ({
  type: t.DELETE_DATA_FEEDS_ERROR,
  error,
});

export const fetchDataFeedsRequest = (): DataFeedFetchRequestAction => ({
  type: t.FETCH_DATA_FEEDS_REQUEST,
});

export const fetchDataFeedsResponse = (payload: DataFeeds): DataFeedFetchResponseAction => ({
  type: t.FETCH_DATA_FEEDS_RESPONSE,
  payload,
});

export const fetchDataFeedsError = (error: string): DataFeedErrorAction => ({
  type: t.FETCH_DATA_FEEDS_ERROR,
  error,
});

export const updateDataFeedsRequest = (
  dataFeed: DataFeed | NewDataFeed,
  cb: NoOp,
): DataFeedUpdateRequestAction => ({
  type: t.UPDATE_DATA_FEEDS_REQUEST,
  payload: dataFeed,
  cb,
});

// the API response will include the DataFeed when creating, or a string response when updating
// if updating this function will be called with the request payload
export const updateDataFeedsResponse = (payload: DataFeed): DataFeedUpdateResponseAction => ({
  type: t.UPDATE_DATA_FEEDS_RESPONSE,
  payload,
});

export const updateDataFeedsError = (error: string): DataFeedErrorAction => ({
  type: t.UPDATE_DATA_FEEDS_ERROR,
  error,
});

export const clearDataFeedsError = (): DataFeedErrorClearAction => ({
  type: t.CLEAR_DATA_FEEDS_ERROR,
});
